import { PropsButton, PropsButtonFilter } from './PropsButton';
import classNames from 'classnames';

import styles from './Button.module.scss';

export const Button = ({
  children,
  className,
  size = 'Medium',
  themes = 'Primary',
  disabled,
  active,
  fullWith,
  ...props
}: PropsButton | PropsButtonFilter): JSX.Element => {
  return (
    <button
      {...props}
      disabled={disabled}
      className={classNames(
        styles.Button,
        styles[themes],
        styles[size],
        active && styles.Active,
        disabled && styles.Disable,
        fullWith && styles.FullWidth,
        className,
      )}
    >
      {children}
    </button>
  );
};
